import './clients-mobile.scss';

import { Pagination } from 'antd';
import { useEffect, useState } from 'react';

import { useWindowSize } from '@/hooks/useWindowSize';
import { getUserInitials } from '@/services/helpers/strings';

import { type TClient } from '../../../types';

interface ClientsMobileProps {
  clients: TClient[];
  isLoading: boolean;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
  };
  onPageChange: (page: number, pageSize: number) => void;
  onClick: (row: TClient) => void;
}

const ClientsMobile: React.FC<ClientsMobileProps> = ({
  clients,
  isLoading,
  pagination: externalPagination,
  onClick,
  onPageChange
}) => {
  const [pagination, setPagination] = useState(externalPagination);
  const [windowWidth] = useWindowSize();

  useEffect(() => {
    setPagination(externalPagination);
  }, [externalPagination]);

  const { current, pageSize, total } = pagination;

  const handleFiltersChange = (page: number, pageSize?: number) => {
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize || prev.pageSize
    }));
  };

  return (
    <div className="clients-mobile">
      {isLoading ? (
        <div className="clients-mobile__loading">Загрузка...</div>
      ) : clients.length > 0 ? (
        clients.map((item) => (
          <div
            key={item.uuid}
            className="clients-mobile__card"
            onClick={() => onClick(item)}
          >
            <div className="clients-mobile__avatar">
              {item.lastName?.[0]?.toUpperCase()}
            </div>
            <div className="clients-mobile__info">
              <div>
                <h3>{getUserInitials(item)}</h3>
                <p>ИИН: {item.clientIin}</p>
              </div>

              <div className="clients-mobile__phone">
                {item.phoneNumber && <p>{item.phoneNumber}</p>}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="clients-mobile__no-results">Ничего не найдено</div>
      )}
      <Pagination
        className="clients-mobile__pagination"
        current={current}
        pageSize={pageSize}
        total={total}
        showSizeChanger={false}
        simple={windowWidth <= 560}
        showLessItems={windowWidth <= 560}
        onChange={(page, pageSize) => {
          handleFiltersChange(page, pageSize);
          onPageChange(page, pageSize);
        }}
      />
    </div>
  );
};

export default ClientsMobile;
